// extracted by mini-css-extract-plugin
export default {"root":"FuelPromoTerms_root__n98Pb","lastUpdated":"FuelPromoTerms_lastUpdated__mmIlY"};